"use client";

import React from 'react';
import styles from '../app/styles/Popup.module.css';
import { IoCloseCircleOutline } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";

const SyllabusPopup = ({ isOpen, onClose, courseTitle, syllabusLink }) => {
  const handleDownload = () => {
    // Open the syllabus link in a new tab
    window.open(syllabusLink, '_blank');
    
    // Close the popup after opening the link
    setTimeout(() => {
      onClose();
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <button 
          onClick={onClose} 
          className={styles.closeButton}
          aria-label="Close"
        >
          <IoCloseCircleOutline size={24} />
        </button>
        
        <div className="text-center">
          <h2 className={styles.title}>Download <span className={styles.highlight}>{courseTitle}</span> Syllabus</h2>
          <p className={styles.subtitle}>Click the button below to download the detailed course syllabus</p>
          
          <button 
            onClick={handleDownload}
            className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center mx-auto"
          >
            <FaDownload className="mr-2" />
            Download Syllabus
          </button>
        </div>
      </div>
    </div>
  );
};

export default SyllabusPopup; 